import { render, staticRenderFns } from "./Showitem.vue?vue&type=template&id=77458eed&scoped=true"
import script from "./Showitem.vue?vue&type=script&lang=js"
export * from "./Showitem.vue?vue&type=script&lang=js"
import style0 from "./Showitem.vue?vue&type=style&index=0&id=77458eed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77458eed",
  null
  
)

export default component.exports